var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ApolloQuery',{attrs:{"query":require('../graphql/Log.gql'),"variables":{ id: _vm.logId },"update":_vm.onUpdate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var data = ref_result.data;
var loading = ref_result.loading;
var error = ref_result.error;
return _c('div',{},[(data)?[(loading)?_c('div',[_c('p',[_vm._v("Loading...")])]):_vm._e(),(error)?_c('div',[_c('p',[_vm._v("There was an error")])]):_c('div',[_c('LogForm',{attrs:{"log":data,"mode":_vm.mode}})],1)]:_vm._e()],2)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }